import React from "react";
import KanbanBoardView from "../../components/Admin/CRM/KanbanBoardView";

const CRMBoard = () => {
  return <KanbanBoardView />;
};

export default CRMBoard;
